import { settings } from '@/resources';
import axios from 'axios';

export default {
  methods: {
    delete: function(url) {
      let headers = {
        headers: {
          Authorization: `${settings.user}|${settings.token}`
        }
      };

      return axios.delete(url, headers);
    },
    get: function(url) {
      let headers = {
        headers: {
          Authorization: `${settings.user}|${settings.token}`
        }
      };

      return axios.get(url, headers);
    },
    post: function(url, data) {
      let headers = {
        headers: {
          Authorization: `${settings.user}|${settings.token}`
        }
      };

      return axios.post(url, data, headers);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utilities/communication.js